import styles from "./css/Header.module.css";

interface HeaderProps {
  type: "choose" | "chat";
  onBackClick?: () => void; // chat 타입일 때만 사용
  userCount?: number;
  onUserCountClick?: () => void;
}

export default function Header({
  type,
  onBackClick,
  userCount = 0,
  onUserCountClick,
}: HeaderProps) {
  return (
    <div className={styles.header}>
      {type === "choose" ? (
        "캐릭터 선택"
      ) : (
        <>
          <span onClick={onBackClick} className={styles.backButton}>
            ←
          </span>
          <span className={styles.userCount} onClick={onUserCountClick}>
            {userCount}명 접속 중
          </span>
        </>
      )}
    </div>
  );
}
